import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import {ApiService} from "../../util/api.service";
import {environment} from "../../../../../environments/environment";
import {HeadersRequest} from "../../util/model/header-request.inteface";

@Injectable()
export class UsuarioService {

  private basePath = environment.basePathOrquestrador;

  constructor(protected apiService: ApiService, @Optional() @Inject('basePath') basePath: string) {
    if (basePath) {
      this.basePath = basePath;
    }
  }

  public consultarTipoUsuario( authorization?: string  ): Observable<any> {
    const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
    headers.push({param: 'Authorization', value: 'Bearer ' + authorization});

    return this.apiService.get<any>(this.basePath + environment.usuario.consultaTipoUsuario, null, headers);
  }

}
